<template>
    <Modal
            v-model="modal"
            title="存货选择"
            :mask-closable="false"
            @on-ok="ok"
            width="800"
            @on-cancel="cancel"
            @on-visible-change="onVisibleChange">
        <Form ref="queryForm" :model="application" inline :label-width="130">
            <Row>
                <Col span="10">
                    <FormItem label="存货编码" prop="cinvcode">
                        <Input type="text" v-model="application.cinvcode" placeholder="请输入存货编码">
                        </Input>
                    </FormItem>
                </Col>
                <Col span="10">
                    <FormItem label="存货名称" prop="cinvname">
                        <Input type="text" v-model="application.cinvname" placeholder="请输入存货名称">
                        </Input>
                    </FormItem>
                </Col>
                <Col span='3' offset='1'>
                    <Button type="primary" @click="application.page = 1;queryTableData2()">查询</Button>
                </Col>
            </Row>
        </Form>
        <CTable :columns="columns" :data="queryData" :total="total" :current="application.page" @change="change"
                @onSelectChange="onSelectChange" :showPage="true"/>
    </Modal>
</template>

<script>
    import CTable from "../../components/CTable/CTable";

    export default {
        name: "SkuSelectDialog",
        components: {CTable},
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                selections: [],
                modal: false,
                queryData: [],
                total: 0,
                application: {
                    page: 1,
                    pageSize: 10,
                },
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    }, {
                        title: '编码',
                        key: 'cinvcode',
                        width: 370,
                    }, {
                        title: '名称',
                        key: 'cinvname',
                        width: 370,

                    }],
            }
        },
        watch: {
            visible(newVal) {
                this.modal = newVal;
                if (newVal) {
                    this.application.page = 1;
                    this.queryTableData2()
                }
            }
        },
        methods: {
            ok() {
                this.$emit('on-select', this.selections)
                this.setShow(false);
            },
            cancel() {
                this.setShow(false);
            },
            setShow(isShow) {
                this.$emit("update:visible", isShow)
            },
            queryTableData2() { // 查询表格
                this.$fetch('SoSomain/getCunhuoList', this.application).then(res => {
                    this.queryData = res.data.list
                    this.total = res.data.total
                })
            },
            change(index) {
                this.application.page = index
                this.queryTableData2()
            },
            onVisibleChange(visible) {
                if (this.visible === visible) {
                    return;
                }
                this.setShow(visible);
            },
            onSelectChange(selection) {
                this.selections = selection
            },
        }

    }
</script>

<style scoped>

</style>
